import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, utils_tool, component_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizNotice, WizBrowserExport } = component_tool;
let { checkStrLength, toChinesNum,Session } = utils_tool;
class OperateRecord extends WizContainer {
  componentName = 'OperateRecord';

  constructor(props) {
    super(props);
    const { history } = props;
    let infoDetail = {};
    if (history.location){
      if (history.location && history.location.record) {
        infoDetail = history.location.record;
        Session.set('infoDetail', infoDetail)
      } else {
        infoDetail = Session.get('infoDetail') || {};
      }
    }
    this.infoDetail = infoDetail;
    this.state = {
    }
  }

  _handleFile(nextProps, nextState, key) {
    let response = nextProps[key]
    const blob =response['result'];
    let link = document.createElement('a');
    let body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = '点赞数据.xls';

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);


  }


  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _render() {
    let pathname = this.props && this.props.location && this.props.location.pathname
    let operateData = {}
    const data = this.infoDetail;
    if (pathname && (pathname === '/interact/community/invitation/invitationAgree' || pathname === '/interact/community/invitation/invitationStep')) {
      let bizType = 24 //帖子
      let bizId = data.searchProps && data.searchProps.invitation && data.searchProps.invitation.id //帖子ID
      let bizName = data.searchProps && data.searchProps.invitation && data.searchProps.invitation.content //帖子内容
      let operateType;
      if (pathname === '/interact/community/invitation/invitationAgree') {
        operateType = 1 //赞
      } else if (pathname === '/interact/community/invitation/invitationStep') {
        operateType = 2 //踩
      }
      operateData = {operateType, bizType, bizId,bizName}
    }
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({ operateData: operateData }),
      apiDataFormat: {
        changeTop: this._handleCMD,
        changeScreen: this._handleCMD,
        export: this._handleFile,
      },
      operateData
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(OperateRecord);
